import React from "react";

export function StatusPill({ status }) {
  const map = {
    approved: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Approved" },
    rejected: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "Rejected" },
    pending: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", label: "Pending" },
  };
  const s = map[status] || map.pending;
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-xs font-medium ${s.bg} ${s.text} ${s.border}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${status === "approved" ? "bg-emerald-500" : status === "rejected" ? "bg-red-500" : "bg-amber-500"}`} />
      {s.label}
    </span>
  );
}

export function RolePill({ role }) {
  return (
    <span
      data-testid={`role-pill-${role}`}
      className="inline-flex items-center px-2 py-0.5 rounded-full border border-zinc-200 bg-zinc-50 text-[11px] font-medium text-zinc-700 uppercase tracking-wider"
    >
      {role}
    </span>
  );
}

export function Kicker({ children }) {
  return <div className="label-kicker">{children}</div>;
}

export function SectionTitle({ kicker, title, action }) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div>
        {kicker ? <Kicker>{kicker}</Kicker> : null}
        <h2 className="text-2xl font-semibold tracking-tight text-zinc-950 mt-1">{title}</h2>
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}

export function LoadingCard({ label = "Loading…", testId = "loading-card" }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-zinc-200 bg-white p-8 flex items-center gap-3 text-zinc-500">
      <div className="w-4 h-4 rounded-full border-2 border-zinc-300 border-t-zinc-900 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorCard({ message = "Something went wrong.", onRetry, testId = "error-card" }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-red-200 bg-red-50 p-6">
      <div className="text-sm text-red-700 font-medium">{message}</div>
      {onRetry ? (
        <button
          data-testid="error-retry-btn"
          onClick={onRetry}
          className="mt-3 inline-flex items-center px-3 py-1.5 rounded-lg bg-white border border-red-200 text-red-700 text-sm hover:bg-red-100"
        >
          Try again
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({ title, description, action, testId = "empty-state" }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-dashed border-zinc-200 bg-white p-10 text-center">
      <h3 className="text-lg font-medium text-zinc-900">{title}</h3>
      {description ? <p className="mt-1 text-sm text-zinc-500">{description}</p> : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  );
}

export const CATEGORIES = ["Food", "Travel", "Office", "Transport", "Lodging", "Other"];
